import React, {Component} from "react"
import Report from '../../Report/Report'
import {Link} from 'react-router-dom'


class PolishingModuleFinish extends Component {
  componentDidMount() {
    const $activeLink = document.querySelector("#root > div > aside > div.aside-point > a:nth-child(4)")
    $activeLink.classList.add('aside-point__active')
  }

  render() {
    const value = '25А 20 СТ1 К6'.split(' ')

    return (
      <React.Fragment>

        <main className='params'>
          <h1 className='params__title'>
            Шлифовальный круг для окончательного
            шлифования
          </h1>

          <div className="params-content">

            <div className="params-content-box">
              <h2 className='polishing__title'>Характеристика круга</h2>
              <div className="polishing__disk">{value.join(' ')}</div>
            </div>

            <div className="params-content-box">
              <div className="polishing-box">
                <div className="polishing-box__item">
                  <h2 className='polishing-box__subtitle'>
                    Припуск на обработку
                  </h2>
                  <div className="polishing-box__border">0,14 мм</div>
                </div>
                <div className="polishing-box__item">
                  <h2 className='polishing-box__subtitle'>
                    Шероховатость после обработки
                  </h2>
                  <div className="polishing-box__border">Ra0,63</div>
                </div>
              </div>
            </div>

            <div className="params-content-box">
              <div className="polishing-box">
                <div className="polishing-box__item">
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Абразивный материал
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[0]}
                    </div>
                  </div>
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Зернистость
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[1]}
                    </div>
                  </div>
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Твердость
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[2]}
                    </div>
                  </div>
                </div>
                <div className="polishing-box__item">
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Связка
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[3].split('')[0]}
                    </div>
                  </div>
                  <div className="polishing-box-wrapper">
                    <h2 className='polishing-box__subtitle'>
                      Структура
                    </h2>
                    <div className="polishing-box__border inline-block">
                      {value[3].split('')[1]}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="polishing-link">
              <Link to='/modules/polishing/start' className="polishing-link__prev">
              </Link>
            </div>


          </div>

        </main>

        <Report/>

      </React.Fragment>
    )
  }
}

export default PolishingModuleFinish